import React, {useState, useEffect, useRef} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import Papa from "papaparse";
import {Button, Layout, Modal, Radio, Input} from "antd";
import {resultColumnData} from './columns';
import {getFindReportIdInfo, getFindAnalysisResultList, postSaveResultUpload, postSaveResultAnalysis, postModifyVaResultData, postAnalysisDelete} from '../../pages/Common/api';
import AnalysisTable from './AnalysisTable.js';
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx';
import SelectBox from '../Common/SelectBox';

const { Content } = Layout;

/** -------------------------------------------------------------------------- **/
function AnalysisResult({ p_reportId, p_resultType, onClose }) {
    const params = useParams();
    const selfFlagRef = useRef(false);
    // 변수 선언
    const [companyCode, setCompanyCode] = useState('');
    const [assetType, setAssetType] = useState('');
    const [reportId, setReportId] = useState(p_reportId);
    const [reportName, setReportName] = useState('');
    const [reportInfo, setReportInfo] = useState({});
    const [resultType, setResultType] = useState(p_resultType);
    const [resultListData, setResultListData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [dataDeleting, setDataDeleting] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    const [spinflag, setSpinflag] = useState(true);
    // const [selfFlag, setSelfFlag] = useState(false); // self 플래그

    const [resMessage, setResMessage] = useState("");
    // State to store parsed data
    const [parsedData, setParsedData] = useState([]);
    //State to store table Column name
    const [tableRows, setTableRows] = useState([]);
    //State to store the values
    const [values, setValues] = useState([]);

    // 진단결과 수정을 위한 조회조건
    const [assetCd, setAssetCd] = useState('');
    const [measureCd, setMeasureCd] = useState('');
    const [resultCd, setResultCd] = useState('');

    //확정여부
    const confirmed = reportInfo.confirm=='Y'?true:false;

    //진단결과-조회조건
    const resultCdSelectOptions = JSON.parse(localStorage.getItem('code_list')).filter(item => item.type == 'result_cd');
    resultCdSelectOptions.push({text: '확인필요', value: 'SELF'})
    //----------------------------------------------------------------------------------------
    // Table 선택박스 설정
    const [selectedRowKeys, setSelectedRowKeys] = useState([]); 
    const onSelectChange = (newSelectedRowKeys) => {
        //console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const csv_headers = [
        { label: "자산코드", key: "asset_cd" },
        { label: "자산이름", key: "asset_nm" },
        { label: "IP주소", key: "asset_ip" },
        { label: "진단항목(체크)", key: "LX1-01-R" },
        { label: " ", key: "LX1-02-R" },
        { label: " ", key: "LX1-03-R" },
        { label: " ", key: "LX1-04-R" },
        { label: " ", key: "LX1-05-R" },
        { label: "진단항목(내용)", key: "LX1-01-SA" },
        { label: " ", key: "LX1-02-SA" },
        { label: " ", key: "LX1-03-SA" },
        { label: " ", key: "LX1-04-SA" },
        { label: " ", key: "LX1-05-SA" },
      ];
      
    const csv_data = [
        { asset_cd: "asset_cd", asset_nm: "asset_nm", asset_ip: "asset_ip", LX1_01_R: "LX1_01_R", LX1_02_R: "LX1_02_R", LX1_03_R: "LX1_03_R", LX1_04_R: "LX1_04_R", LX1_05_R: "추가항목...", LX1_01_SA: "LX1_01_SA", LX1_02_SA: "LX1_02_SA", LX1_03_SA: "LX1_03_SA", LX1_04_SA: "LX1_04_SA",LX1_05_SA: "추가항목..."},
        { asset_cd: "LX001",  asset_nm: "isecure web01", asset_ip: "251.12.12.56", LX1_01_R: "Y", LX1_02_R: "N", LX1_03_R: "SELF", LX1_04_R: "Y", LX1_05_R: "추가결과...", LX1_01_SA: "■ 현황---", LX1_02_SA: "■ 현황---", LX1_03_SA: "■ 현황---", LX1_04_SA: "■ 현황---", LX1_05_SA: "추가결과..."},
        { asset_cd: "" },
        { asset_cd: "" },
        { asset_cd: "■ 첫 줄은 반드시 삭제해야 합니다." },
        { asset_cd: "■ 자산유형에 따라 진단항목 코드(LX1-01, DB1-01, WS1-01,...)는 달라지므로 취약점분석기준의 진단항목코드를 확인해주세요." },
        { asset_cd: "■ 진단결과는 필수값으로 Y/N/SELF 중에서 입력해주세요." },
        { asset_cd: "■ LX1_01_R(체크) : 진단항목에 대한 진단여부(Y/N/SELF) 기입" },
        { asset_cd: "■ LX1_01_SA(내용) : 진단항목에 대한 진단내용(■현황:---) 기입" },
    ];

    const titleName = (resultType == 'C') ? '최초분석' : '이행점검';
    //----------------------------------------------------------------------------------------
    // 레포트 조회
    const findAnalysisInfo = () => {
        //자동조회
        if(reportId) {
            let count=0;
            axios.get(getFindReportIdInfo(reportId))
                .then((response) => {
                    count=response.request.responseText.length;
                    setReportInfo(response.data[0]);
                    setCompanyCode(response.data[0].com_cd);
                    setAssetType(response.data[0].asset_type);
                    setReportName(response.data[0].report_nm);
                    setReportId(response.data[0].report_id);
                })
                .catch((error) =>  Modal.error({title:titleName, content:error.message}))
                .finally(() => setTimeout(() => setSpinflag(false), 800));
        }
    }

    // 결과 조회
    const findAnalysisResultList = () => {

        setShowUpload(false);
         // 선택정보 초기화
        setSelectedRowKeys([]);
        if(reportId && resultType) {
            // try{
            //     const res = await axios.get(getFindAnalysisResultList(reportId, resultType, assetCd, measureCd, resultCd));
            //     // 데이타 핸들링을 위하여 Key값 추가
            //     const updateList = res.data.map((data) => ({
            //         ...data,
            //         key: data.id,
            //     }));
            //     setResultListData(updateList);
            // }catch(error){
            //     console.log("AnalysisResult.js --- 130 error");
            //     console.dir(error);
            // }
         
            axios.get(getFindAnalysisResultList(reportId, resultType, assetCd, measureCd, resultCd))
                .then((response) => {
                    //console.log(response);
                    // 데이타 핸들링을 위하여 Key값 추가                    
                    const updateList = response.data.map((data) => ({
                        ...data,
                        key: data.id,
                    }));
                    
                    setResultListData(updateList);
                })
                .catch((error) => Modal.error({title:titleName, content:error.message}));
        }
    }

    // 파일업로드
    const onChangeUploadHandler = (event) => {
        setShowUpload(true);
        setIsDataChange(false);
        // const keyRegex = /[ ]*self[ ]*/i;
        
        // Passing file data (event.target.files[0]) to parse using Papa.parse
        if(event.target.files[0]){

            // setSelfFlag((prevSelfFlag)=>{ return false; });
            Papa.parse(event.target.files[0], {
                header: true,
                skipEmptyLines: 'greedy',
                complete: (results) => {
                    const rowsArray = [];
                    const valuesArray = [];
                    let keyNameCount=0;
                    let keyNameOrgCount=0;
                    let keyName = "";
                    let keyBreak=true; // selfFlag로 확인하면 파일 2번째 업로드시 적용이 안되는 부작용이 있어 별도 로컬변수 사용 

                    // 오브젝트값이 배열로 들어온다. [ {키1:값1, 키2:값2}, {키1:값1, 키2:값2}, {키1:값1, 키2:값2} ]
                    results.data.map((d) => {
                        let i=0;

                        // 헤더 필드가 필요하기 때문에 한번만 실행하면 됨  [ {키1:값1, 키2:값2 } , 뒤는 필요없음 ]
                        if(keyNameCount===0){
                            // 키1, 키2 을 배열로 가져옴 
                            keyName = Object.keys(d);
                            keyNameCount = keyName.length;
                            // asset_cd,name,ip 제외하고 값부분만 가져옴(현황도 제외)  
                            keyNameOrgCount = keyNameCount-((keyNameCount-3)/2);
                            rowsArray.push(keyName);
                        }

                        // self 값이 있는거 확인 되면 이후 확인 안해도 됨 
                        // if(keyBreak){
                        //     for(i=3; keyNameOrgCount>i; i++){
                        //         if( keyRegex.test(d[keyName[i]]) ){
                        //             setSelfFlag(true);
                        //             keyBreak=false;
                        //             break;
                        //         }
                        //     }
                        // }

                        valuesArray.push(Object.values(d));
                    });

                    // Parsed Data Response in array format
                    setParsedData(results.data);

                    // Filtered Column Names
                    setTableRows(rowsArray[0]);

                    // Filtered Values
                    setValues(valuesArray);
                },
            });
        }
    };

    // 파일 Key값 체크
    function isKeyCheck(element) {
        if(element.asset_type != assetType) {
            return false;
        }
        return true;
    };

    // 저장
    const onClickSaveHandler = () => {
        // 필수조건 체크
        if (reportId == '' || resultType == '') {
            Modal.info({title:titleName, content:"Report Id, Result Type이 누락되었습니다."});
            return;
        }
        // if(!parsedData.find(isKeyCheck)) {
        //     Modal.error({title: "There is data that does not match the condition."});
        //     return;
        // }

        setUploading(true);
        setSpinflag(true);
        setIsDataChange(false);

        axios.post(postSaveResultUpload(), {
            reportId : reportId,
            resultType : resultType,
            parsedData : parsedData,
          }, {logCompany : companyCode, logParam : reportId})
          .then((response) => {
            setUploading(false);
            setSpinflag(false);

            if( response.data.status === "success"
                // response.data?.message == "취약점 분석 결과 수정 및 위험 평가 완료"
            ) {
                let nowMessage=[];
                let i=0;

                for(let objData of response.data.message.warnings){
                    if(objData.description){
                        nowMessage.push(objData);
                        ++i;
                    }
                }
                console.dir(nowMessage);
                const nowContent=(
                    <>
                    <div style={{fontWeight:"bold", padding:"3px 0 5px 0"}}> 성공적으로 데이터가 입력되었습니다.</div>
                    <table className="rms-popup-border">
                        <tbody>
                        {nowMessage.map((message, index) => (
                            <>
                            <tr  style={{backgroundColor:"#ededed"}} key="a{index}"><td>{message["description"]}</td></tr>
                            {message["items"].map((asset, id) => (                  
                                <>             
                                <tr key="b{index}{id}"><td>{asset}</td></tr>
                                </>
                            ))}
                            {/* <tr key="b{index}"><td>{message["items"].join()}</td></tr> */}
                            </>
                        ))}
                        </tbody>
                    </table>
                    </>
                );
                
                Modal.info({title: titleName, content:nowContent, okText:"Close", onOk() {
                    // 결과내용 재조회
                    setIsDataChange(true);
                }});
            } else {
                let today = new Date();   
                // let message = "■ "+response.data.status;
                // if(response.data['IP가 다름'].length < 1 && response.data['Name이 다름'].length < 1 ){
                //     message = message +"\n템플릿이 다르거나 자산파일에 누락된 필드(자신이름, ip) 정보가 있는지 확인해 주세요";
                // }else{
                //     message = message + "\n● IP가 다른 자산\n"+(response.data['IP가 다름'] && response.data['IP가 다름'].length > 0 ?  JSON.stringify(response.data['IP가 다름']) : '없음');
                //     message = message + "\n● Name이 다른 자산\n"+(response.data['Name이 다름'] && response.data['Name이 다름'].length > 0 ?  JSON.stringify(response.data['Name이 다름']) : '없음');
                // }
                // message = message + "\n● 신규자산\n"+(response.data['새로운 자산'] && response.data['새로운 자산'].length > 0 ?  JSON.stringify(response.data['새로운 자산']) : '없음');

                // const Table = () => ( <table border="1"> <tr><td>7</td></tr> </table> );
                // setResMessage(<Table />);
                setResMessage(response.data.status.differences.sort((a, b) => { if (a.mismatch_type < b.mismatch_type) return -1;  if (a.mismatch_type > b.mismatch_type) return 1;  return 0; }));
            }
        })
        .catch((error) => {
            setUploading(false);
            setSpinflag(false);
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });
    
    };

    // 결과분석
    const onClickAnalysisHandler = () => {

        // 필수조건 체크
        if (!resultListData.length || resultListData.length == 0) {
            Modal.info({title:titleName, content:"결과를 먼저 등록하세요."});
            return;
        }

        // 진단결과 피일 값에서 SELF 체크
        //if(selfFlag){
        if(selfFlagRef.current){
            Modal.info({
                title: titleName, 
                content: ( <> 취약점진단 결과 값에 <span style={{color:'red',fontWeight:'bold'}}>'SELF'</span> 값이 있습니다.<br />'Y' 또는 'N'으로 결정하여 올려주시기 바랍니다. </>), 
                okText: "Close",
                width:450
              });            
            return;
        }

        setIsLoading(true);
        setIsDataChange(false);
        axios.post(postSaveResultAnalysis(), {
            reportId : reportId,
            resultType : resultType,
          }, {logCompany : companyCode, logParam : reportId})
          .then((response) => {
            setIsLoading(false);

            // if(response.data.length > 0) {
            if(response.data.status == "success") {
                let message = '';
                let nowMessage=[];
                let i=0;
                
                if(resultType == 'U') {
                    message = '※ 이행진단의 결과가 등록되지 않은 자산은 초기진단 결과로 분석됩니다.'
                }

                for(let objData of response.data.message.warnings){
                    if(objData.description){
                        if(objData.description =="일부 자산 정보가 DB에 없는데 분석되었습니다.") objData.description = (<p>자산에는 없고 진단 결과에만 포함되어 있음<br/>(자산:X 파일:O)</p>);
                        else if(objData.description == "DB에 있는 자산에 대한 분석이 누락되었습니다.") objData.description = (<p>자산에 있지만 진단 결과에 포함되어 있지 않음<br/>(자산:O 파일:X)</p>);
                        nowMessage.push(objData);
                        ++i;
                    }
                }

                const nowContent=(
                    <>
                    <div style={{fontWeight:"bold", padding:"3px 0 5px 0"}}> 성공적으로 데이터가 분석되었습니다.</div>
                    <div style={{fontWeight:"bold", color:"blue"}}> {message}</div>
                    {nowMessage.length >0 ? <div style={{fontWeight:"bold", padding:"2px 0 5px 0"}}>아래 표에 있는 누락자산은 분석 되지 않았습니다.</div>:"" }
                    <table className="rms-popup-border" width="100%">
                        <tbody>
                        {nowMessage.map((message, index) => (
                            <>
                            <tr style={{backgroundColor:"#ededed"}} key="a{index}"><td colspan={2}>{message["description"]}</td></tr>
                            <tr key="b{index}"><td>누락자산</td><td><p>{message["assets"].join()}</p></td></tr>
                            </>
                        ))}
                        </tbody>
                    </table>                    
                    </>
                );
                               
                Modal.info({title: "결과 분석 성공", content:nowContent, okText:"Close", onOk() {
                    // 결과내용 재조회
                    setIsDataChange(true);
                    setResultCd('');
                }});
            } else {
                Modal.info({title: "결과 분석 실패", content:response.data, okText:"Close"});  
            }
        })
        .catch((error) => {
            setIsLoading(false);
            let thisMsg = error.response.data != "" ? error.response.data.message : error.message;
            if(error.response.data.status === "fail"){
                Modal.error({title:titleName, content:"결과 분석 업로드 오류", content: thisMsg, okText:"Close"});
            }else{
                Modal.error({title:titleName, content:"결과 분석 업로드 오류", content: thisMsg, okText:"Close"});
            }
        });
    
    };
    // (수정)저장 클릭 시
    const onClickModifyHandler = (saveData) => {

        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveModifyVaResultData(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

    }

    // 진단결과 수정 API
    const saveModifyVaResultData = (saveData) => {
        setIsDataChange(false);
        // try{
        //     const req = await axios.post(postModifyVaResultData()
        //     , {reportId : reportId, resultType : resultType, saveData : saveData}
        //     , {logCompany : companyCode, logParam : reportId});

        //     if(req.data.message == '취약점 분석 결과 수정 및 위험 평가 완료') {
        //         Modal.confirm({title: "진단결과가 변경되어 [결과분석]을 재실행해야 합니다.", 
        //                         content: "바로 [결과분석]을 실행하시겠습니까?",
        //                         okText:"Yes", cancelText:"No",
        //                         onOk : onClickAnalysisHandler,
        //                         onCancel : setIsDataChange(true)
        //                 });
        //     } else {
        //         Modal.info({title: response.data.message+"--", okText:"Close"});  
        //     }
        // }catch(error){
        //     console.log("AnalysisResult.js --- 371 error");
        //     Modal.info({title: "Error.", okText:"Close"});
        // }

        axios.post(postModifyVaResultData()
                        , {reportId : reportId, resultType : resultType, saveData : saveData}
                        , {logCompany : companyCode, logParam : reportId})
        .then((response) => {
            // if(response.data.status == 'success') {
            if(response.data.status == 'success') {
                // setResultListData(prevData => {
                //     return [...prevData, ...saveData];
                // });
                setIsDataChange(true);
                Modal.confirm({title: "진단결과가 변경되어 [결과분석]을 재실행해야 합니다.....", 
                                content: "바로 [결과분석]을 실행하시겠습니까?",
                                okText: "Yes", 
                                cancelText: "No",
                                onOk : onClickAnalysisHandler,
                                // onOk: () => {
                                //     findAnalysisResultList(); // 데이터 재조회
                                //     onClickAnalysisHandler(); // 분석 실행
                                // },
                                // onCancel: close
                                // onOk : onClickAnalysisHandler,
                                // onCancel : setIsDataChange(true)
                        });
            } else {
                Modal.info({title: response.data.message, okText:"Close"});  
            }
        })
        .catch((error) => {
            Modal.error({title: "Error.", okText:"Close"});
        });
    };
    
    // self값 조회 
    useEffect(() =>{

        let resultListDataCount = resultListData.length;
        const keyRegex = /.*SELF/i;

        selfFlagRef.current = false;
        for(let i = 0; i < resultListDataCount; i++) {
            if(keyRegex.test(resultListData[i]["result_cd"])) {
                selfFlagRef.current = true;
                break;
            }
        }

    }, [resultListData]);

    // 정보 변경시 재조회
    useEffect(() => {
        if(isDataChange) { findAnalysisResultList(); }
    }, [isDataChange]);    

    useEffect(() => {
        findAnalysisInfo();
    }, []);

    // 결과 조회
    useEffect(() => {
        findAnalysisResultList();
    }, [reportId]);

    // 진단결과 선택 시 자동 조회
    useEffect(() => {
        console.log('resultCd changed:', resultCd, 'reportId:', reportId);
        if (resultCd && reportId) {
            console.log('Auto-searching with resultCd:', resultCd);
            findAnalysisResultList();
        }
    }, [resultCd]);

    const csvHeaders = [
        { label: "자산코드", key: "asset_cd" },
        { label: "현황", key: "mismatch_type" },
        { label: "자산이름", key: "asset_nm" },
        { label: "IP", key: "asset_ip" }
    ];


    const downloadExcel = (data, filename) => {
        console.dir(data);

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.utils.sheet_add_aoa(worksheet, [["자산코드", "현황", "자산이름", "IP"]], { origin: "A1" });
        
        // Merge cells for rowspan
        const merges = [];
        let currentRow = 1;
        data.forEach((row, index) => {
            if (!row.mismatch_type || row.mismatch_type === "") {
                merges.push({ s: { r: currentRow-1, c: 0 }, e: { r: currentRow, c: 0 } });
                merges.push({ s: { r: currentRow-1, c: 1 }, e: { r: currentRow, c: 1 } });
                currentRow += 1;
            } else {
                currentRow++;
            }
        });

        worksheet['!merges'] = merges;   
        XLSX.writeFile(workbook, `${filename}.xlsx`);
    };

    useEffect(() => {
        if(resMessage) {  
            const csvData = resMessage.flatMap((dataSrc) => {
                
                if (Object.keys(dataSrc).length > 4) {
                    if(dataSrc["asset_name"]){
                        return [
                            {
                                asset_cd: dataSrc["db_asset_cd"],
                                mismatch_type: dataSrc["mismatch_type"],
                                asset_nm: dataSrc["asset_name"],
                                asset_ip: dataSrc["json_ip"]

                            },
                            {
                                asset_cd: "",
                                mismatch_type: "",
                                asset_nm: dataSrc["asset_name"],
                                asset_ip: dataSrc["db_ip"]
                            }
                        ];
                    }else{
                        return [
                            {
                                asset_cd: dataSrc["db_asset_cd"],
                                mismatch_type: dataSrc["mismatch_type"],
                                asset_nm: dataSrc["json_name"],
                                asset_ip: dataSrc["asset_ip"]

                            },
                            {
                                asset_cd: "",
                                mismatch_type: "",
                                asset_nm: dataSrc["db_name"],
                                asset_ip: dataSrc["asset_ip"]
                            }
                        ];
                    }

                } else {
                    // 신규자산으로 인식 할 때
                    return {
                        asset_cd: dataSrc["asset_cd"],
                        mismatch_type: dataSrc["mismatch_type"],
                        asset_nm: dataSrc["asset_nm"],
                        asset_ip: dataSrc["asset_ip"]
                    };
                }
            });
            
            Modal.info({
              title: "자산 등록 오류", 
              content: ( <>
                <table className="rms-popup-border" width="100%">
                    <tbody>
                    <tr style={{backgroundColor:"#ededed"}}><td>자산코드</td><td>현황</td><td>자산이름</td><td>IP</td></tr>

                    { resMessage.map((dataSrc, index) => (
                        console.log(Object.keys(dataSrc).length),
                        <React.Fragment key={index}>                    
                            { (Object.keys(dataSrc).length > 4) ? (
                                    (dataSrc["asset_name"]) ? (
                                        <> <tr><td rowSpan={2}>{dataSrc["db_asset_cd"]}</td><td rowSpan={2}>{dataSrc["mismatch_type"]}</td><td rowSpan={2}>{dataSrc["asset_name"]}</td><td>{dataSrc["json_ip"]}</td></tr> 
                                        <tr><td>{dataSrc["db_ip"]}</td></tr> </>
                                    ):(
                                        <> <tr><td rowSpan={2}>{dataSrc["db_asset_cd"]}</td><td rowSpan={2}>{dataSrc["mismatch_type"]}</td><td>{dataSrc["json_name"]}</td><td rowSpan={2}>{dataSrc["asset_ip"]}</td></tr> 
                                        <tr><td>{dataSrc["db_name"]}</td></tr> </>
                                    )
                                ):(
                                    <><tr><td>{dataSrc["asset_cd"]}</td><td>{dataSrc["mismatch_type"]}</td><td>{dataSrc["asset_nm"]}</td><td>{dataSrc["asset_ip"]}</td></tr></>
                                )
                            }
                        </React.Fragment>
                    )) } 
                    </tbody>
                </table> 
                {/* <CSVLink
                    data={csvData}
                    headers={csvHeaders}
                    filename={"error_message.csv"}
                >
                    <button style={{ position: "absolute", bottom: "20px" }}>다운로드</button>
                </CSVLink> */}
                <Button onClick={() => downloadExcel(csvData, "error_message")} style={{ position: "absolute", bottom: "20px", padding: "0px 5px 10px 5px" }}>
                    엑셀다운로드
                </Button>
                </>
                ), 
            // content: ( <>
            //         { resMessage.split('\n').map((line, index) => (
            //         <React.Fragment key={index}>
            //             {index === 0 ? <b>{line}</b> : 
            //             /^● /.test(line) ? <b>{line}</b> : line }<p />
            //         </React.Fragment>
            //         )) } 
            //         </>
            //     ), 
              okText: "Close",
              width:620
            });
            setResMessage("");
          }
    }, [resMessage]);

    // 닫기
    const onClickCloseHandler = () => {
        //window.close();
        onClose?.(true);
    }

    // 조회
    const onClickSearchCdHandler = () => {
        // 선택된 조건에 대하여 조회
        findAnalysisResultList();
    }

    const onClickDeleteHandler = () => {
        if(reportId){
            
            setDataDeleting(true);
            setSpinflag(true);

            axios.post(postAnalysisDelete(), {reportId : reportId}).then((response) => {
                // if(response.data.status == 'success') {
                setIsDataChange(true);

                if(response.data === "보고서 삭제가 완료되었습니다.") {
                    Modal.info({title:titleName, content:"리포트가 삭제 되었습니다", okText:"Close"});
                } else {
                    Modal.info({title:titleName, content:response.data.message, okText:"Close"});  
                }
            }).catch((error) => {
                Modal.error({title:titleName, content:error.message, okText:"Close"});
            }).finally(()=>{
                setDataDeleting(false);
                setSpinflag(false);
            });
        }
    }
    //----------------------------------------------------------------------------------------
    return (
    <div className='layer_overlay'>
        <div className='layer_wrap' style={{width:Math.ceil( window.innerWidth - 100 ), height:Math.ceil( window.innerHeight - 200 )}}>
            <div className='popup_header'>
                <div className='popup_title'>
                    {titleName} : 취약점분석 결과
                </div>
            </div>
            <div className="popup_button" style={{top:'10px'}}>  
                {confirmed ? (
                    <><span style={{color : '#ff0000', fontSize: '11px'}}>확정된 보고서로 진단결과 수정이 불가합니다.</span></>
                    ) : (
                    <>
                        <Button
                            type="default"
                            style={{marginRight: '10px'}}
                        >
                            <CSVLink 
                                data={csv_data} 
                                headers={csv_headers} 
                                filename={'결과분석_업로드양식'}>
                                {'샘플 다운'}
                            </CSVLink>
                        </Button>

                        {!confirmed ? (
                            <input
                                type="file"
                                name="file"
                                className='ant-btn-primary'
                                style={{padding: '4px 15px'}}
                                onChange={onChangeUploadHandler}
                                accept=".csv, .txt"
                            />
                        ) : (
                            <></>
                     )}
                        {showUpload? (
                            <Button
                                type="primary"
                                onClick={onClickSaveHandler}
                                loading={uploading}
                                disabled={(tableRows.length && tableRows.length > 0) ? false : true}
                                style={{marginRight: '10px'}}
                            >
                                {'저장'}
                            </Button>
                            ) : (
                                <></>
                        )}
                        <Button
                            type="primary"
                            onClick={onClickAnalysisHandler}
                            loading={isLoading}
                            disabled={(resultListData.length && resultListData.length > 0) ? false : true}
                            style={{marginRight: '10px'}}
                        >
                            {'결과분석'}
                        </Button>
                        {resultType == 'C' ? (
                            <Button
                                type="primary"
                                onClick={onClickDeleteHandler}
                                loading={dataDeleting}
                                disabled={(resultListData.length && resultListData.length > 0) ? false : true}
                                style={{marginRight: '10px'}}
                            >
                                    {'결과분석 삭제'}
                            </Button>
                        ) : (
                            <Button
                                type="primary"
                                onClick={onClickDeleteHandler}
                                loading={dataDeleting}
                                disabled={(resultListData.length && resultListData.length > 0) ? false : true}
                                style={{marginRight: '10px'}}
                            >
                                    {'결과분석 삭제'}
                            </Button>
                        )}
                    </>
                )}
                <Button
                    type="default"
                    onClick={onClickCloseHandler}
                    style={{marginLeft: '10px'}}
                >
                    {'닫기'}
                </Button>
            </div>
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{width:'10%'}} />
                        <col style={{width:'12%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'12%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'18%'}} />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th>자산구분</th>
                        <td>{assetType}</td>
                        <th>취약점분석명</th>
                        <td>{reportName}</td>
                        <th><span className='req'>*</span>취약점분석ID</th>
                        <td>{reportId}</td>
                        <th><span className='req'>*</span>결과유형</th>
                        <td>{titleName}
                            {/* <!-- Radio.Group id={resultType} disabled={true} value={resultType}>
                                <Radio value={'C'}>최초분석</Radio>
                                <Radio value={'U'}>이행점검</Radio>
                            </Radio.Group --> */}
                        </td>
                    </tr>
                    {!showUpload? (
                          <tr>
                            <th>자산코드</th>
                            <td><Input id="assetCd" size="small"
                                   allowClear
                                   value={assetCd}
                                   onChange={(event) => {setAssetCd(event.target.value)}}
                                /></td>
                            <th>진단코드</th>
                            <td><Input id="measureCd" size="small"
                                   allowClear
                                   value={measureCd}
                                   onChange={(event) => {setMeasureCd(event.target.value)}}
                                /></td>
                            <th>진단결과</th>
                            <td colSpan={3}>
                                <SelectBox tag='resultCd' 
                                    options={resultCdSelectOptions} 
                                    value={resultCd}  
                                    onChangeHandler={(value) => {
                                        setResultCd(value);
                                    }} />
                                <Button
                                    type="primary"
                                    onClick={onClickSearchCdHandler}
                                    style={{marginLeft: '10px'}}
                                >
                                {'조회'}
                            </Button>
                            </td>
                        </tr>
                    ) : (  
                        <>
                        </>
                    )}
                    </tbody>
                </table>
            </div>
            {showUpload ? (
                <div className="section" id="uploadTable">      
                    <Content style={{ height: 450, backgroundColor: '#fff', overflow: 'scroll'}}>
                        <table>
                            <thead>
                            <tr>
                                {tableRows.map((rows, index) => {
                                return <th key={index}>{rows}</th>;
                                })}
                            </tr>
                            </thead>
                            <tbody>
                            {values.map((value, index) => {
                                return (
                                <tr key={index}>
                                    {value.map((val, i) => {
                                        return <td key={i}>{val}</td>;
                                    })}
                                </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </Content>
                </div>
            ) : (
                <div className="section" id="resultTable">
                    <AnalysisTable
                        data={resultListData} 
                        columnData={resultColumnData}
                        reportId={reportId}
                        reportInfo={reportInfo}
                        isLoading={isLoading} 
                        onClickSaveHandler={onClickModifyHandler}
                        rowSelection={rowSelection}
                        selectedRowKeys={selectedRowKeys}
                        spinflag={spinflag}
                    />
                </div>
            )}
        </div>
    </div>
    );
}
export default AnalysisResult;